import { render, staticRenderFns } from "./UsedRawMaterialsSection.vue?vue&type=template&id=8f9f960a&scoped=true&"
import script from "./UsedRawMaterialsSection.vue?vue&type=script&lang=js&"
export * from "./UsedRawMaterialsSection.vue?vue&type=script&lang=js&"
import style0 from "./UsedRawMaterialsSection.vue?vue&type=style&index=0&id=8f9f960a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9f960a",
  null
  
)

export default component.exports